let productMetadataTypes;

const isVehicleUseValid = ({ modelVM }) => {
    const { spmDrivers, spmVehicle } = modelVM.lobData.privateMotor.coverables;

    const gwApplicationTypeList = productMetadataTypes.getTypelist('GwApplication_Ext');
    const unemployedCategory = gwApplicationTypeList.getCode('Portals_Unemployed_Statuses');
    const commutingOrBusinessCategory = gwApplicationTypeList.getCode('Portals_Comm_Bus_Vehicle_Uses');

    const vehicleUse = spmVehicle.vehicleUse.value;
    if (!vehicleUse) {
        return true;
    }

    const commutingOrBusinessUse = vehicleUse.belongsToCategory(commutingOrBusinessCategory);
    if (commutingOrBusinessUse) {
        const drivers = spmDrivers.children.filter((driver) => driver.value.isPolicyHolder || driver.value.isSpouseOrPartner);
        return drivers.some((driver) => {
            if (driver.employmentStatus.value === undefined) {
                return true;
            }
            return !driver.employmentStatus.value.belongsToCategory(unemployedCategory)
                || (driver.partTimeOccupation.value === true && driver.partTimeOccupationType.value !== undefined);
        });
    }

    return true;
};

export default {
    init(viewModelService) {
        productMetadataTypes = viewModelService.productMetadata.get('pc').types;
    },
    isVehicleUseValid
};
